import { ComponentProps, FC, useContext } from 'react'
import { config, styled } from '../../../config/stitches'
import { AlertContext } from '../AlertContext'

const Root = styled('div', {
  fontWeight: '$semibold',
  fontSize: '14px',
  marginRight: '8px'
})

export const AlertTitle: FC<ComponentProps<typeof Root>> = ({ children, css, ...rest }) => {
  const { colorScheme } = useContext(AlertContext)

  return (
    <Root css={{ color: config.theme.colors[colorScheme.textColor], ...css }} {...rest}>
      {children}
    </Root>
  )
}
